import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { ProductLinkWithIcon, TitleWithIcon, User } from 'components/common';
import { Popover } from 'components/common/popover';

import type { AchievementData } from 'shared-types';

interface Props {
  addedBy: AchievementData['addedBy'];
  enableLink?: boolean;
  style?: React.CSSProperties;
}

const AchievementRenderAddedBy = ({
  addedBy,
  enableLink = false,
  style
}: Props) => {
  const { messages } = useReduxState();

  return !addedBy ? null : typeof addedBy === 'string' ? (
    <div style={{ fontSize: '1.4rem' }}>{addedBy}</div>
  ) : addedBy.addedByType === 'path' ? (
    addedBy.paths.length === 1 ? (
      <ProductLinkWithIcon
        key={addedBy.paths[0].id}
        path={addedBy.paths[0]}
        disableLink={!enableLink}
        showTooltip={true}
        titleStyle={{ fontWeight: 600 }}
      />
    ) : (
      <div style={{ display: 'inline-block' }}>
        <Popover
          content={
            <div
              className="content"
              style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
            >
              {addedBy.paths.map((path) => (
                <ProductLinkWithIcon
                  key={path.id}
                  path={path}
                  titleStyle={{ fontWeight: 600 }}
                />
              ))}
            </div>
          }
        >
          {(setIsOpen) => (
            <TitleWithIcon
              avatarProps={{
                fontSize: '1.1rem',
                padding: '6px 0',
                size: '24px'
              }}
              icon="tasks"
              onClick={() => setIsOpen(true)}
              titleStyle={{ fontWeight: 600, marginTop: 3 }}
              title={getMessageWithPlaceholders({
                message: messages.pathsNumberOfLearningPaths,
                placeholders: { numberOfPaths: addedBy.paths.length }
              })}
            />
          )}
        </Popover>
      </div>
    )
  ) : addedBy?.addedByType === 'user' ? (
    <User
      enableProfileLink={enableLink}
      size="small"
      user={addedBy}
      style={style}
    />
  ) : addedBy?.addedByType === 'integration' ? (
    <ProductLinkWithIcon
      disableLink={true}
      integration={addedBy}
      showTooltip={true}
      style={style}
      titleStyle={{ fontWeight: 600 }}
    />
  ) : addedBy?.addedByType === 'calendarEvent' ? (
    <ProductLinkWithIcon
      calendarEvent={addedBy}
      disableLink={!enableLink}
      showTooltip={true}
      style={style}
      titleStyle={{ fontWeight: 600 }}
    />
  ) : null;
};

export default AchievementRenderAddedBy;
